<template>
  <transition name="dialog">
    <div class="dialog" v-if="model" @click.self="handleClose">
      <slot></slot>
    </div>
  </transition>
</template>
<script setup>
import { onMounted } from 'vue';
const props = defineProps({
  'close-on-click-overlay': {
    type: Boolean,
    default: true,
  },
});

const model = defineModel();
function handleClose() {
  if (props['closeOnClickOverlay']) {
    model.value = false;
  } else {
    return;
  }
}
watch(model, (v) => {
  if (v == true) {
    document.body.classList.add('tx-dialog-hidden');
  } else {
    document.body.classList.remove('tx-dialog-hidden');
  }
});
onMounted(() => {
  if (model.value == true) {
    document.body.classList.add('tx-dialog-hidden');
  }
});
</script>
